<template>
  <div>
    <div v-if="isVisible" class="wrapper">
      <AppButtonCancel @click="discard">保存せず終了</AppButtonCancel>
      <AppButtonOk :loading="loading" @click="save" color="primary">
        保存
      </AppButtonOk>
    </div>
  </div>
</template>

<script>
import { getters, actions } from '@/vuex/modules/pointGroupOperation/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'SaveOrCancelPointList',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    targetGroup() {
      return this.$store.getters[getters.targetGroup]
    },
    isVisible() {
      return !!this.targetGroup.id
    },
    hasUpdates() {
      return this.$store.getters[getters.targetGroupHasUpdates]
    },
    locationListToDelete() {
      const locationList = this.$store.getters[getters.currentPointList]
      return locationList.filter(location => location.toDelete)
    },
  },
  methods: {
    async save() {
      // 削除がある場合は確認する。
      if (this.locationListToDelete.length) {
        const result = await this.$confirm(
          'グループから以下の地点が完全に削除されてしまいますがよろしいですか？',
          {
            body: this.locationListToDelete
              .map(point => `・${point.name}`)
              .join('\n'),
          },
        )
        if (!result) return
      }
      //activeの地点数が0の場合はエラーモーダルを出す。
      if (
        !this.$store.getters[getters.currentPointList].filter(
          locationPoint => locationPoint.status === 'active',
        ).length > 0
      ) {
        const statusError = await this.$confirm('入力エラー', {
          okText: '閉じる',
          onlyOk: true,
          body: `地点グループには、1地点以上の有効な地点が必要です。
                 有効な地点を設定してください。`,
        })
        if (statusError) return
      }
      this.loading = true
      // 保存処理
      try {
        await this.$store.dispatch(actions.SAVE)
        this.loading = false
        await this.$store.dispatch(actions.RESET_TARGET_GROUP)
        await this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
      } catch (e) {
        this.loading = false
        const error = new Error('保存に失敗しました。')
        throw error
      }
    },
    async discard() {
      const result = await this.$confirm(
        '追加・編集が破棄されますがよろしいですか？',
      )
      if (result) {
        this.$store.dispatch(actions.RESET_TARGET_GROUP)
      }
    },
  },
}
</script>

<style scoped></style>
